import { Box } from "app/layout/Box/Box";
import { LinkWithTime } from "app/links/LinkWithTime/LinkWithTime";
import React from "react";
import { analysisDetailUrl } from "app/analysis/urls";
import { SectionHeader } from "app/layout/SectionHeader/SectionHeader/SectionHeader";
import { VisualHeadlineSize } from "app/layout/Headline/Headline";

import "./style.scss";

export interface Props {
    items: {
        isin: string;
        time: string;
        title: string;
        id: string;
    }[];
}

export const AnalysisLinks = ({ items }: Props) => {
    return (
        <div className="analysisLinks">
            <SectionHeader headline="Analystenmeinungen" visualHeadlineSize={VisualHeadlineSize.REGULAR} />
            <div>
                {items.map(analysis => (
                    <LinkWithTime
                        key={analysis.id}
                        time={analysis.time}
                        title={analysis.title}
                        url={analysisDetailUrl(analysis.isin, analysis.id, analysis.title)}
                    />
                ))}
            </div>
        </div>
    );
};
